module.exports = __webpack_public_path__ + "img/meter1.aac66ef8.png";